import CheckboxInput from './Checkbox';

export default CheckboxInput;
